import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@utils/window/window.provider';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(@Inject(WINDOW) private window: Window) {}

  public get(key: string): any {
    const value = this.window.localStorage.getItem(key);
    if (value) {
      try {
        return JSON.parse(value);
      } catch (ex) {
        return value;
      }
    } else {
      return null;
    }
  }

  public set(key: string, data: any): void {
    if (this.get(key)) {
      this.remove(key);
    }
    this.window.localStorage.setItem(key, JSON.stringify(data));
  }

  public remove(key: string): void {
    if (this.get(key)) {
      this.window.localStorage.removeItem(key);
    }
  }
}
